import {
    CorrectionMapEditorValue,
    ExperimentsEditorData,
    ExperimentsSaveValue
} from '../typings/experimentsEditor';
import { RateControlValue } from '../typings/ratesCorrections';

export function mapCorrectionsToEditor(
    correctionsMap: Record<number, RateControlValue>
): Record<number, CorrectionMapEditorValue> {
    return Object.keys(correctionsMap).reduce((acc, nodeId) => {
        acc[nodeId] = {
            value: correctionsMap[nodeId],
            errors: []
        };
        return acc;
    }, {});
}

export function mapCorrectionsToCampaignValue(
    correctionsMap: Record<number, CorrectionMapEditorValue>
): Record<number, RateControlValue> {
    return Object.keys(correctionsMap).reduce((acc, nodeId) => {
        acc[nodeId] = correctionsMap[nodeId].value;

        return acc;
    }, {});
}

export function mapEditorExperimentsToCampaignExperiments(
    editorData: ExperimentsEditorData
): ExperimentsSaveValue {
    return {
        selectedMap: editorData.selectedMap,
        areCorrectionsEnabled: editorData.areCorrectionsEnabled,
        isSegmentTargetingEnabled: editorData.isSegmentTargetingEnabled,
        correctionsMap: mapCorrectionsToCampaignValue(editorData.correctionsMap)
    };
}
